var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialog-popup',{attrs:{"dialog":_vm.show,"label":_vm.OrgObjectType,"ghostText":_vm.ghostText,"description":_vm.description,"type":_vm.type,"buttonLabel":_vm.buttonLabel,"orgObjectType":_vm.OrgObjectType,"isShowCharCounter":true,"maxWidth":'430'},on:{"dialogItem":_vm.addDialogItems,"back":_vm.backDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }